import React, { useState } from "react";
import { DeletePopup } from "../../../../shared/components/table/components/DeletePopup";
import { RowOptionsButtonContainer } from "../../../../shared/components/TableElements";
import { RowOptionsMenuWrap } from "../../../../shared/components/table/components/RowOptions";
import { OptionsMenu } from "../../../../shared/components/table/components/MoreOptions/MoreOptions";
import DocumentRenewalsFormPopup from "../DocumentRenewalsFormPopup";
import useClickAway from "../../../../shared/custom-hooks/useClickAway";
import { useTranslation } from "react-i18next";
import ErrorPopup from "../../../../shared/components/ErrorPopup";
import MarkDocumentRenewedPopup from "./MarkDocumentRenewedPopup";
import { useAuth } from "../../../../contexts/AuthContext";

const DocRenewalsRowOptions = ({ rowData, setSnackbarMsg }) => {
  const { isViewOnly } = useAuth();
  const [toggleOptions, setToggleOptions] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const [showErrPopup, setShowErrPopup] = useState(false);
  const [showDocRenewalFormPopup, setShowDocRenewalFormPopup] = useState(false);
  const [showMarkAsRenewedPopup, setShowMarkAsRenewedPopup] = useState(false);

  const clickAwayRef = useClickAway({
    handleCloseElement: () => setToggleOptions(false),
  });

  const handleClick = (e) => {
    e.preventDefault();
    setToggleOptions(!toggleOptions);
  };

  if (isViewOnly) {
    return null;
  }
  return (
    <>
      {showErrPopup && (
        <ErrorPopup showPopup={showErrPopup} setShowPopup={setShowErrPopup} />
      )}
      {showDeletePopup && (
        <DeletePopup
          showPopup={showDeletePopup}
          setShowPopup={setShowDeletePopup}
          deleteApiData={{
            delete_ids: rowData.doc_renewal_id,
            querystring: "multiple_delete",
            sub_query_string: "DOCUMENT_RENEWALS",
          }}
          screen={"documentrenewals"}
          //setShowInfoPopup={setShowInfoPopup}
          //setInfoData={setInfoData}
        />
      )}
      {showDocRenewalFormPopup && (
        <DocumentRenewalsFormPopup
          showPopup={showDocRenewalFormPopup}
          setShowPopup={setShowDocRenewalFormPopup}
          type={"edit"}
          rowData={rowData}
          setSnackbarMsg={setSnackbarMsg}
        />
      )}

      {showMarkAsRenewedPopup && (
        <MarkDocumentRenewedPopup
          showPopup={showMarkAsRenewedPopup}
          setShowPopup={setShowMarkAsRenewedPopup}
          rowData={rowData}
          setShowErrPopup={setShowErrPopup}
        />
      )}
      <div
        className="d-flex align-items-start justify-content-center position-relative"
        ref={clickAwayRef}
      >
        <RowOptionsButtonContainer
          id="row-options-button"
          style={{ marginTop: 0 }}
          variant="outline-secondary"
          size="sm"
          onClick={handleClick}
        >
          <i className="fi fi-rr-menu-dots-vertical"></i>
        </RowOptionsButtonContainer>

        {toggleOptions && (
          <RowOptionsMenu
            rowData={rowData}
            toggleOptions={toggleOptions}
            setToggleOptions={setToggleOptions}
            //setMode={setMode}
            setShowDocRenewalFormPopup={setShowDocRenewalFormPopup}
            setShowDeletePopup={setShowDeletePopup}
            setShowMarkAsRenewedPopup={setShowMarkAsRenewedPopup}
          />
        )}
      </div>
    </>
  );
};

export default DocRenewalsRowOptions;

const RowOptionsMenu = ({
  toggleOptions,
  setToggleOptions,
  rowData,
  setShowDocRenewalFormPopup,
  setShowDeletePopup,
  setShowMarkAsRenewedPopup,
}) => {
  const { t } = useTranslation("common");

  const handleMarkAsRenewed = () => {
    setShowMarkAsRenewedPopup(true);
    setToggleOptions(false);
  };

  const handleEdit = () => {
    setShowDocRenewalFormPopup(true);
    setToggleOptions(false);
  };

  const handleDelete = () => {
    setShowDeletePopup(true);
    setToggleOptions(false);
  };

  return (
    <RowOptionsMenuWrap id="row-options" style={{ width: "150px" }}>
      <OptionsMenu id="mark-as-renewed-button" onClick={handleMarkAsRenewed}>
        {t("mark_as_renewed")}
      </OptionsMenu>

      <OptionsMenu id="edit-button" onClick={handleEdit}>
        {t("edit")}
      </OptionsMenu>

      <OptionsMenu id="delete-button" onClick={handleDelete}>
        {t("delete")}
      </OptionsMenu>
    </RowOptionsMenuWrap>
  );
};
